import React from 'react';

class Card extends React.Component {
 


    render(){ 
       

        
        
        return (
                <div  className="card"  >
                        <img src={this.props.details.thumb} alt=""/>
                    
                    <h2>{this.props.details.name}</h2>
                   <p>{this.props.details.role.substring(0,70) + "..."}</p>
                    <a href="" className="explore">Explore</a>
                </div>
            
        );
    } 
}

export default Card;